export default __webpack_public_path__ + "static/media/Scope-3.c05299ad.png";